function descriptorFormController() {
  const ctrl = this;
  ctrl.$onInit = () => {
    ctrl.newDescriptor = {
      type: null,
      revision: null,
      value: null,
      status: null,
      compatibility: null,
      modification: null,
    };

    ctrl.hwCompatibilities = [];
    ctrl.allDescriptors = [];
    ctrl.filteredHWDescriptors = [];

    ctrl.statusListSoftware = [
      { id: 0, type: 'Sanctioned', disabled: false },
      { id: 1, type: 'Engineering', disabled: false },
      { id: 2, type: 'Valid', disabled: false },
      { id: 3, type: 'Deprecated', disabled: false },
    ];
    
    ctrl.allDescriptors = ctrl.resolve.descriptors;
    ctrl.moduleList = ctrl.resolve.moduleList;
    ctrl.moduleList = ctrl.moduleList.sort((a,b) => (a.module > b.module) ? 1 : ((b.module > a.module) ? -1 : 0))
    ctrl.versionAvailable = true;
    ctrl.hasAutoUpload = __env.profile === 'LU'
  };

  ctrl.onTypeChoiceChange = () => {
    ctrl.filteredDescriptor = ctrl.allDescriptors.find(obj => obj.type === ctrl.newDescriptor.type);
    if (ctrl.filteredDescriptor !== undefined) {
      ctrl.filteredHWDescriptors = ctrl.filteredDescriptor.hw_revision;
      if (ctrl.filteredDescriptor.sw_revision.length > 0 && ctrl.newDescriptor.type !== "AVI_DB") {
        _.each(ctrl.filteredDescriptor.sw_revision, version => {
          let option;
          if (version.status === 'Sanctioned' && version.type !== "AVI_DB") {
            option = ctrl.statusListSoftware.find(item => item.type === 'Sanctioned');
          } else if (version.status === 'Valid' && version.type !== "AVI_DB") {
            option = ctrl.statusListSoftware.find(item => item.type === 'Valid');
          } else if (version.status === 'Engineering' && version.type !== "AVI_DB") {
            option = ctrl.statusListSoftware.find(item => item.type === 'Engineering');
          }
          if (option) {
            option.disabled = true;
          }
        });
      }
    } else {
      ctrl.filteredHWDescriptors = [];
    }
    ctrl.hwCompatibilities = [];
  };

  ctrl.hwCompatibilityChecked = event => {
    if (ctrl.hwCompatibilities.indexOf(event) !== -1) {
      ctrl.hwCompatibilities.splice(ctrl.hwCompatibilities.indexOf(event), 1);
    } else {
      ctrl.hwCompatibilities.push(event);
    }
  };

  ctrl.processDescriptor = () => {
    ctrl.descriptorObject = {
      type: ctrl.newDescriptor.type,
      sw_revision: ctrl.newDescriptor.value,
      sw_revision_status: ctrl.newDescriptor.status,
      compatible_hw: ctrl.hwCompatibilities,
    };
  };

  ctrl.saveDescriptor = () => {
    ctrl.processDescriptor();
    ctrl.clearForm();
    ctrl.close({ $value: ctrl.descriptorObject });
  };

  ctrl.checkVersion = () => {
    if (!ctrl.filteredDescriptor) {
        ctrl.versionAvailable = true;
    } else {
      let versionFound = false;
      for (let descriptor of ctrl.filteredDescriptor.sw_revision) {
        if (descriptor.version_number === ctrl.newDescriptor.value) {
          versionFound = true;
          ctrl.versionAvailable = false;
        }
      }
      if (!versionFound) {
        ctrl.versionAvailable = true;
      }
    }
  };

  ctrl.clearForm = () => {
    ctrl.newDescriptor = {
      type: null,
      revision: null,
      value: null,
      status: null,
      modification: null,
    };
    ctrl.hwCompatibilities = [];
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('package-management.module')
  .controller('descriptorFormController', descriptorFormController);
